import { logger } from '@/utils/logger';
import { DashboardMainLayout } from '@/modules/routing/layouts/DashboardMainLayout';
import appServices from '@/services/appServices';
import { createFileRoute, redirect } from '@tanstack/react-router';

const authService = appServices.auth;

export const Route = createFileRoute('/dashboard')({
  component: RouteComponent,
  beforeLoad: () => {
    logger.debug('Dashboard beforeLoad check');

    // Rule 1: if go to dashboard, if not authenticated go to auth
    if (!authService.isAuthenticated()) {
      logger.debug('Not authenticated, redirecting to /auth');
      throw redirect({
        to: '/auth',
      });
    }

    // Rule 2: if authenticated but onboarding not completed, go to onboarding
    const userSettings = authService.getUserSettings();
    if (userSettings?.onboarding_completed !== 'true') {
      logger.debug('Onboarding not completed, redirecting to /onboarding');
      throw redirect({
        to: '/onboarding',
      });
    }

    logger.debug(
      'Authenticated and onboarding completed, proceeding to dashboard'
    );
  },
});

function RouteComponent() {
  return <DashboardMainLayout />;
}
